var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9V15C22 16.1 21.1 17 20 17H19V15H20V9H4V15H10V17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H20C21.1 7 22 7.9 22 9ZM14.5 19L15.59 16.59L18 15.5L15.59 14.41L14.5 12L13.41 14.41L11 15.5L13.41 16.59L14.5 19ZM17 14L17.62 12.62L19 12L17.62 11.38L17 10L16.38 11.38L15 12L16.38 12.62L17 14ZM14.5 19L15.59 16.59L18 15.5L15.59 14.41L14.5 12L13.41 14.41L11 15.5L13.41 16.59L14.5 19ZM17 14L17.62 12.62L19 12L17.62 11.38L17 10L16.38 11.38L15 12L16.38 12.62L17 14Z",
    fill: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCta);
export default __webpack_public_path__ + "static/media/add_cta.58bdaab0cfc4bb2482af49fc48fec5c2.svg";
export { ForwardRef as ReactComponent };